import styled from 'styled-components';

export const ContentWrapper = styled.div<{ isCollapsed: boolean }>`
  margin-left: ${({ isCollapsed, theme }: { isCollapsed: boolean; theme: any }): string =>
    isCollapsed ? `${theme.constants.sideBar.width.collapsed}px` : `${theme.constants.sideBar.width.full}px`};
  box-sizing: border-box;
  transition: margin-left 0.3s ease;
`;
